<template>
  <div class="modal topup-modal">
    <div class="overlay" @click="$parent.closeTopUpModal"></div>
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img class="close" @click="$parent.closeTopUpModal" src="./../images/close.svg" />
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <div class="title">{{ $t('TOP UP BALANCE') }}</div>
                <div class="amount-section">
                  <div class="currency-label">{{ currency }}</div>
                  <div class="input-with-controls">
                    <input type="text" maxlength="14" @input="allowOnlyNumbers" v-model="amount" class="amount-input" />
                    <div class="amount-controls">
                      <button class="amount-btn minus-btn" @click="decreaseAmount">-</button>
                      <button class="amount-btn plus-btn" @click="increaseAmount">+</button>
                    </div>
                  </div>
                </div>
                <button 
                  :disabled="$parent.minOrderAmount && $parent.minOrderAmount > amount" 
                  @click="toCheckout" 
                  class="button"
                >{{ $t('TOP UP BALANCE') }}</button>
                <transition name="slide">
                  <div v-if="$parent.error" class="error-desc desc red">
                    {{ $parent.error }}
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopUpModal",
  props: ['currency'],
  components: {},
  data: function () {
    return {
      amount: 5
    };
  },
  mounted() {},
  methods: {
    allowOnlyNumbers(){
      this.amount = this.amount.replace(/[^0-9.,]/g, '');
      const parts = this.amount.split(/[.,]/);
      let integerPart = parts[0] || '';
      let decimalPart = parts[1];
      if (integerPart.length > 12) {
        integerPart = integerPart.slice(0, 12);
      }
      if (decimalPart !== undefined && decimalPart.length > 2) {
        decimalPart = decimalPart.slice(0, 2);
      }
      this.amount = decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;
    },
    increaseAmount() {
      const currentAmount = parseFloat(this.amount) || 0;
      this.amount = (currentAmount + 1).toString();
    },
    decreaseAmount() {
      const currentAmount = parseFloat(this.amount) || 0;
      if (currentAmount > 1) {
        this.amount = (currentAmount - 1).toString();
      }
    },
    toCheckout() {
      this.$emit('setTopUpAmount', this.amount);
    },
  },
};
</script>
